import {
  Supertype,
  supertypeClass,
  property,
  remote,
  Remoteable,
  Persistable,
  amorphicStatic,
} from '@haventech/amorphic';
import {
  IsomorphicPersistent,
  Persistent,
  IsomorphicQuery,
  Query,
  Isomorphic,
  Serializable,
  AppController,
  SubController,
  Everything,
} from '@hit/amorphic-types';
import { Expense } from './Expense';
import { CashFlow } from './CashFlow';

@supertypeClass({ toClient: true, toServer: true })
export class HealthCare extends Expense {
  @property({ rule: ['currency'] })
  singleCost: number;

  @property({ rule: ['currency'] })
  familyCost: number;

  constructor() {
    super();
  }

  static new(customer) {
    return new HealthCare().init(customer);
  }

  init(customer) {
    super.init(customer, 'healthcare', 0, 'Health Care');

    this.calculateCosts();
    return this;
  }

  isActive(deceased?) {
    return this.inCashFlow(deceased);
  }

  inCashFlow(deceased?) {
    return !this.customer.capitalNeeds.earnedIncome[deceased === this.customer.primaryCustomer ? 1 : 0].hasHealthCare;
  }

  resetCosts() {
    this.calculateCosts(true);
  }

  calculateCosts(force?) {
    if (force || this.singleCost === null || typeof this.singleCost === 'undefined') {
      this.singleCost = this.customer.assumptions.healthCareCosts[this.customer.profile.state][0];
      this.familyCost = this.customer.assumptions.healthCareCosts[this.customer.profile.state][1];
    }
  }

  getSingleCost() {
    this.calculateCosts();

    return this.singleCost;
  }

  getFamilyCost() {
    this.calculateCosts();

    return this.familyCost;
  }

  getStartingFlow(deceased) {
    const flow = <any>super.getStartingFlow(deceased);

    this.calculateCosts();
    flow.amount = [this.singleCost, this.familyCost];

    return flow;
  }

  getAmount(flow, year, _deceased, yearOfDeath) {
    if (year < yearOfDeath) {
      return 0;
    }

    if (year > flow.endYear) {
      return 0;
    }

    const parentIndex = this.customer.capitalNeeds.children.length > 0 ? 1 : 0;

    return 0 - flow.amount[year > this.customer.capitalNeeds.getLeaveTheNestYear() ? 0 : parentIndex];
  }

  adjustFlow(flow) {
    flow.amount[0] *= 1 + this.customer.settings.inflation;
    flow.amount[1] *= 1 + this.customer.settings.inflation;
  }

  getEndYear(deceased) {
    return this.customer.capitalNeeds.getMedicareYear(deceased);
  }
}
